//
//
//
//
//
//
//
//
//
//
//
//

import { getIcon } from './utils'
export default {
    data () {
        return {
            list: [
                {
                    pic: getIcon('web_720'),
                    link: '/list/web_720'
                },
                {
                    pic: getIcon('map_buildings'),
                    link: '/map_buildings'
                },
                {
                    pic: getIcon('vr_buildings'),
                    link: '/list/vr'
                }
            ]
        }
    }
}
